export default __webpack_public_path__ + "static/media/Insta.aab625dd.svg";